import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import Home from "../pages/ZoneOverview/Home";
import NotFoundPage from "../pages/NotFound/NotFoundPage";
import LoginPage from "../pages/Login/LoginPage";
import ZoneNetworkConfiguration from "../pages/ZoneNetworkConfiguration/ZoneNetworkConfiguration";
import { ProtectedRoute } from "../Utils/Protected.Route";
export const customHistory = createBrowserHistory();
/**
 * @component  RouteConfig
 * @description Route Configuration for the project
 * @returns Redirected Component
 */
const RouteConfig = () => {
  return (
    <div>
      <Switch>
        <Route exact path="/">
          <Redirect to="/login" />
        </Route>
        <Route exact path="/login" component={LoginPage} />
        <ProtectedRoute exact path="/home" component={Home} />
        <ProtectedRoute
          exact
          path="/configuration"
          component={ZoneNetworkConfiguration}
        />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </div>
  );
};

export default RouteConfig;
